var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSproutStreamlineFlex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05359 21.9465C3.77249 20.6277 7.75439 19.1615 12 19.1615C16.2456 19.1615 20.2275 20.6277 21.9464 21.9465",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21294 9.55528C2.1422 7.85462 1.41877 4.19258 2.66947 2.44672C4.54508 1.40057 8.10236 2.53178 9.55901 4.78087C10.7827 6.67032 10.0522 8.16049 8.78389 9.29322C7.50754 10.4331 5.95257 10.984 4.21294 9.55528Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.286 19.1614C12.5346 14.611 11.3246 11.094 6.91406 7.0293",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2734 19.149C12.9448 16.0407 14.2845 12.2781 16.2581 10.199",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8769 6.50112C17.159 4.75483 20.0838 4.01026 21.548 4.94344C22.4749 6.41178 21.7175 9.33321 19.9657 10.6078C18.4939 11.6785 17.2588 11.1541 16.2888 10.1798C15.3126 9.19937 14.7997 7.96816 15.8769 6.50112Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSproutStreamlineFlex1);
export default __webpack_public_path__ + "static/media/Sprout--Streamline-Flex 1.da6a70d2da093013ff027359c2d9a961.svg";
export { ForwardRef as ReactComponent };